import React, { useEffect } from 'react'

import { useAlertsTableData } from "Pages/ReportsAlerts/Alerts/@hooks"
import { BACKEND_APIS } from "@constants"
import { offices, reports } from "@signals"
import { setLastOfficeSubmitted } from "Pages/ReportsAlerts/Alerts/Notifications/@signals"
import { alertsSection, isNoAvailabilityTabLoading, isNoAvailabilityTabEmpty } from "Pages/ReportsAlerts/Alerts/@signals"
import { ALERTS } from "Pages/ReportsAlerts/Alerts/@constants"
import { Grid } from "@mui/material"
import AlertsBaseTable from "Pages/ReportsAlerts/Alerts/@components/Table"
import { conditionNameColumn } from "Pages/ReportsAlerts/Alerts/Notifications/NoAvailability/columns"
import { comparatorColumn, diffColumn, lorColumn, pickupDateColumn, siteColumn } from "Pages/ReportsAlerts/Alerts/Notifications/@components"
import { batch } from "@preact/signals-react"
import { isTourDemoActive } from "@signals/app"


export default function NoAvailabilityBlock() {

	const {
		getTableData,
		tableData,
		isTableLoading
	} = useAlertsTableData(`${BACKEND_APIS.NOTIFICATIONS}/not-available`)

	useEffect(() => {
		if (!!offices.value && !!reports.value) {
			isNoAvailabilityTabLoading.value = true
			isNoAvailabilityTabEmpty.value = false
			getTableData({ idReportExecution: reports.value, idOfficePickup: offices.value })
				.then(data => { isNoAvailabilityTabEmpty.value = !data?.length })
				.finally(() => batch(() => {
					isNoAvailabilityTabLoading.value = false
					setLastOfficeSubmitted()
				}))
		}
	}, [reports.value, offices.value])

	if (alertsSection.value !== ALERTS.NO_AVAILABILITY) return <></>
	if (isTourDemoActive.value && !tableData?.length) return <></>

	return <Grid item xs={12}>
		<AlertsBaseTable
			title="Notifications: Not Available"
			data={tableData}
			isLoading={isTableLoading}
			columns={[
				conditionNameColumn(),
				pickupDateColumn(),
				lorColumn(),
				...comparatorColumn("category", "Category"),
				...comparatorColumn("acriss", "Acriss"),
				...comparatorColumn("fuelPolicy", "Fuel Policy"),
				...comparatorColumn("transmission", "Transmission"),
				...comparatorColumn("mileage", "Mileage"),
				...siteColumn(),
				...comparatorColumn("provider", "Provider"),
				diffColumn()
			]}
		/>
	</Grid>
}